import { createApp } from 'vue';
import casestudies from './App.vue';
createApp(casestudies).mount('#find-bdm');
